var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m220.357 7.18h-220.357v493.225h220.357c7.35 0 14.333 1.587 20.643 4.416v-476.999c0-11.382-9.26-20.642-20.643-20.642zm-29.726 424.073h-140.262v-30h140.262zm0-81.231h-140.262v-30h140.262zm7.646-123.739h-153.623v-30h11.415v-8.675c0-30.897 21.545-56.84 50.396-63.64v-19.547h30v19.547c28.851 6.8 50.396 32.743 50.396 63.64v8.675h11.415v30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.643 7.18c-11.383 0-20.643 9.26-20.643 20.642v476.998c6.31-2.829 13.292-4.416 20.643-4.416h220.357v-493.224zm169.988 424.073h-140.262v-30h140.262zm0-81.231h-140.262v-30h140.262zm0-81.23h-140.262v-30h140.262zm0-81.23h-140.262v-30h140.262zm0-81.231h-140.262v-30h140.262z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.465 152.212c-19.518 0-35.396 15.879-35.396 35.396v8.675h70.792v-8.675c.001-19.517-15.878-35.396-35.396-35.396z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.28703baa08b9dfeccebe8b4e6effe262.svg";
export { ForwardRef as ReactComponent };